import React, { useState } from 'react';
import { FaPlane, FaKey, FaFileAlt, FaTicketAlt, FaSuitcase, FaCar, FaLaptop, FaPhone, FaWallet } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function EmergencyCourierServices() {
  const courierServices = [
    {
      service: "Passport",
      description: "Forgotten your passport right before an important trip? We ensure your passport is delivered swiftly so you don’t miss your flight and can travel hassle-free.",
      icon: <FaPlane className="text-4xl text-black" />,
    },
    {
      service: "House Keys",
      description: "Locked out of your house or need to get keys to someone urgently? We’ll deliver your house keys promptly, allowing you or your recipient to access the home without delays.",
      icon: <FaKey className="text-4xl text-black" />,
    },
    {
      service: "Urgent Documents",
      description: "Need to send critical business documents or contracts? We provide fast and secure delivery to ensure your important paperwork reaches its destination on time.",
      icon: <FaFileAlt className="text-4xl text-black" />,
    },
    {
      service: "Tickets",
      description: "Forgot your concert, sports event, or travel tickets? We’ll get them to you or your loved ones quickly, so you don’t miss out on the event.",
      icon: <FaTicketAlt className="text-4xl text-black" />,
    },
    {
      service: "Luggage",
      description: "Left your luggage behind or need it delivered urgently? We transport your baggage swiftly, ensuring you have everything you need for your journey or event.",
      icon: <FaSuitcase className="text-4xl text-black" />,
    },
    {
      service: "Car Keys",
      description: "Misplaced or forgotten your car keys? We’ll deliver them to your location immediately, so you can get back on the road without any delay.",
      icon: <FaCar className="text-4xl text-black" />,
    },
    {
      service: "Laptop or Macbook",
      description: "Left your Laptop or Macbook at home or office before an important meeting? We ensure it reaches you fast, so you can stay productive and on schedule.",
      icon: <FaLaptop className="text-4xl text-black" />,
    },
    {
      service: "Phone",
      description: "Forgotten your phone and need it urgently? We’ll deliver it to you promptly, keeping you connected and reachable.",
      icon: <FaPhone className="text-4xl text-black" />,
    },
    {
      service: "Wallet",
      description: "Left your wallet behind and need your cards or ID? We’ll deliver it securely, ensuring you have your essentials without the stress.",
      icon: <FaWallet className="text-4xl text-black" />,
    },
    {
      service: "Purse",
      description: "Need your purse delivered urgently? We ensure it reaches you quickly, providing peace of mind and convenience.",
      icon: <FaWallet className="text-4xl text-black" />,
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[600px]"
        style={{ backgroundImage: "url('images/emergency1.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold tracking-tight">Emergency Courier Services</h1>
        </div>
      </div>

      {/* Courier Services List Section */}
      <section id="courier-services" className="py-16 bg-white text-black flex items-center justify-center">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 px-4 md:px-20">
          {courierServices.map((service, index) => (
            <div key={index} className="group flex flex-col items-start gap-4 text-xl ">
              <div className="flex items-center gap-4">
                <div className="text-4xl ">{service.icon}</div>
                <h3 className="font-thin text-xl">{service.service}</h3>
              </div>
              <p className="text-zinc-400 max-w-xs text-base font-thin ">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Situations and Introduction Section */}
      <section className="py-16 bg-white text-black text-center px-4">
        <h2 className="text-4xl font-thin mb-4">Are You in Any of These Situations?</h2>
        <ul className="space-y-4 text-lg font-thin">
          <li>"I need an emergency collection!"</li>
          <li>"I have a super urgent collection!"</li>
          <li>"I need an emergency courier!"</li>
          <li>"I need something delivered urgently!"</li>
          <li>"I have forgotten my ID, passport, office keys, car keys, house keys, medication, concert, or sports event tickets!"</li>
        </ul>
        <p className="mt-6 text-2xl md:text-3xl font-thin">First things first... Don't worry!</p>
        <p className="mt-2 text-lg font-thin text-center lg:px-40">
          At 1UKLogistics, we understand that emergencies can happen at any time. That’s why our services are available 24/7, ready to tackle every industry and deliver your urgent items the same day. Whether you’ve forgotten essential items or have an urgent collection, we are here to provide you with peace of mind and efficient service.
        </p>
       
        <div className='flex justify-center'>
      <Link to='/contactus'>
    <button className="mt-6 py-3 px-6 bg-slate-900 text-white font-semibold  "> GET EMERGENCY QUOTE</button></Link>
    </div>
      </section>
    </div>
  );
}

export default EmergencyCourierServices;
